import type { Enum } from '@shared-types/enum.types';

export type RelevancyMosaicDesign =
  | 'default'
  | 'blocks-basic'
  | 'blocks-small'
  | 'blocks-large'
  | 'blocks-mixed'
  | 'mosaic-square'
  | 'mosaic-single'
  | 'mosaic-adaptive';
export const RelevancyCardFormat = {
  SQUARE: 'square',
  SQUARE_OVER: 'square-over',
  SQUARE_UNDER: 'square-under',
  WIDE: 'wide',
  PORTRAIT: 'portrait',
} as const;
export type RelevancyCardFormat = Enum<typeof RelevancyCardFormat>;

export const RelevancyCardType = {
  ARTICLE: 'ARTICLE',
  VIDEO: 'VIDEO',
  PHOTO_GALLERY: 'PHOTO_GALLERY',
  MATCH: 'MATCH',
  ALL_MATCHES: 'ALL_MATCHES',
  LINEUP: 'LINEUP',
  GROUP_STANDINGS: 'GROUP_STANDINGS',
  FORM_GUIDE: 'FORM_GUIDE',
  DRAW: 'DRAW',
  COMPETITION_WINNER: 'COMPETITION_WINNER',
  LIVE_BLOG: 'LIVE_BLOG',
  HEAD_TO_HEAD: 'HEAD_TO_HEAD',
  INJURIES_AND_SUSPENSIONS: 'INJURIES_AND_SUSPENSIONS',
  LIVE_AUDIO: 'LIVE_AUDIO',
  MATCH_SUMMARY: 'MATCH_SUMMARY',
  PERFORMANCE_ZONE: 'PERFORMANCE_ZONE',
  WEB_LINK: 'WEB_LINK',
  TICKET_PROMOTION: 'TICKET_PROMOTION',
  TOP_SCORER: 'TOP_SCORER',
  FREESTYLER: 'FREESTYLER',
  SPECTATOR_OPTED_IN: 'SPECTATOR_OPTED_IN',
  SPECTATOR_NOT_OPTED_IN: 'SPECTATOR_NOT_OPTED_IN',
  SIGNUP: 'SIGNUP',
  BRACKET_PREDICTOR: 'BRACKET_PREDICTOR',
  GAMING: 'GAMING',
  ALL_STANDINGS: 'ALL_STANDINGS',
  HIGHLIGHT_GROUP: 'HIGHLIGHT_GROUP',
  SKILLS_GROUP: 'SKILLS_GROUP',
  SKILLS_GROUP_EIDOS: 'SKILLS_GROUP_EIDOS',
  MATCH_TEAM_STATISTICS: 'MATCH_TEAM_STATISTICS',
  COMPETITION_COUNTDOWN: 'COMPETITION_COUNTDOWN',
  CONTENT_LIST: 'CONTENT_LIST',
  ARTICLE_GROUP: 'ARTICLE_GROUP',
  STATIC: 'STATIC',
  ROUND_TEAMS: 'ROUND_TEAMS',
  PLAYER_SEASON_STATS: 'PLAYER_SEASON_STATS',
  TEAM_SEASON_STATS: 'TEAM_SEASON_STATS',
  DOCUMENT: 'DOCUMENT',
  EIDOS_CONTENT: 'EIDOS_CONTENT',

  // custom types
  TEAM_OF_THE_WEEK: 'TEAM_OF_THE_WEEK',
  PLAYERS_TO_WATCH: 'PLAYERS_TO_WATCH',
  PODCAST: 'PODCAST',
  QUIZARENA: 'QUIZARENA',
} as const;
export type RelevancyCardType = Enum<typeof RelevancyCardType>;

export type RelevancyCard = {
  cardId: string;
  competitionCode?: string;
  pinned?: boolean;
  subCards?: RelevancyCard[];
  subType?: string;
  teaser: any;
  type: RelevancyCardType;

  // additional fields
  hidden?: boolean;
  error?: boolean;
};

export type RelevancyFeedOptions = {
  cardsNumber?: number;
  wideCardIndex?: number;
  wideCardPeriod?: number;
  webContainer?: string;
  teamId?: string;
  playerId?: string;
  associationId?: string;
  venueId?: string;
  kinds?: string;
  sections?: string;
  hashtags?: string;
  phase?: string;
  useEidos?: boolean;
  workFolder?: string;
  startDate?: string;
  endDate?: string;
  disableSponsors?: boolean;
  season?: string;
  limit?: number;
  skip?: number;
  mediaTypes?: string[];
  topScorerSeason?: string;
  topScorersIndex?: number;
  audioCardIndex?: number;
  Components?: {
    [name: string]: string;
  };
  visibleItems?: number;
  visibleItemsMobile?: number;
  primaryButtons?: boolean;
  moreNewsLink?: string;
  moreVideosLink?: string;
  showDate?: boolean;
  excludedIds?: string[];
  competitionCode?: string;
  relevanceApiUrl?: string;
  relevancy_version?: string;
  webComponentUrl?: string;
  testRelevanceUrl?: string;
  infiniteScroll?: boolean;
  showAssociation?: boolean;
  rooflineType?: 'section' | 'kind' | 'competition';
  rooflineTop?: boolean;
  showRoofline?: boolean;
  isPortrait?: boolean;
  /** The cards will be all squared */
  isSquare?: boolean;
  isOver?: boolean;
  trackingCategory?: string;
  iconNames?: string[];
  /**List of pairs of card index and column span to apply different column span eg. 0=2&1=2*/
  cardsIndexSpanPairs?: string;
  design?: RelevancyMosaicDesign;
};

/**Tha classification of edios article that should be rendered as GamingComponent https://uefa.atlassian.net/wiki/x/EgCi9*/
export const GotxClassification = {
  GoalOfTheTournament: '3rd Parties/GOTT',
  GoalOfTheWeek: '3rd Parties/GOTW',
  /** for Goal of the Matchday (former Goal of the Week) */
  GoalOfTheMatchday: '3rd Parties/GOTM',
  GoalOfTheDay: '3rd Parties/GOTD',
  GoalOfTheCompetition: '3rd Parties/GOTC',
  GoalOfTheRound: '3rd Parties/GOTR',
  PlayerOfTheWeek: '3rd Parties/POTW',
} as const;
export type GotxClassification = Enum<typeof GotxClassification>;
